// extracted by mini-css-extract-plugin
export default {"ProfilePic":"g8fLhFYgaPjkUoA_QVv5"};